export default {
  CHANGE_DATE: 'CHANGE_DATE',
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  ADD_REMINDER: 'ADD_REMINDER',
  EDITING_REMINDER: 'EDITING_REMINDER',
  DELETE_REMINDER: 'DELETE_REMINDER',
}
